import script from "./ListarQuestoesAvaliacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarQuestoesAvaliacoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarQuestoesAvaliacoes.vue?vue&type=style&index=0&id=204ee952&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-204ee952"]])

export default __exports__